import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";
import { CONTACT } from "../lib/content";

export const Footer = () => (
  <footer className="band" data-testid="site-footer">
    <div className="wrap grid gap-10 py-14 md:grid-cols-[1.4fr_1fr_1fr]">
      <div className="flex flex-col gap-4">
        <LogoMark light className="h-10 w-10 text-band-foreground" />
        <p className="max-w-sm font-serifg text-3xl italic leading-tight text-band-foreground">
          Kauaʻi takes care of Kauaʻi.
        </p>
        <p className="max-w-md text-sm leading-relaxed text-band-muted">
          KAMALAMA FOUNDATION is a tax-exempt charitable organization
          recognized under Section 501(c)(3) of the Internal Revenue Code.
          Priced Out of Kauaʻi by Lowell is a program of Kamalama Foundation.
        </p>
      </div>
      <div className="flex flex-col items-start gap-3 text-sm">
        <p className="eyebrow !text-band-foreground/60">Explore</p>
        {[
          ["/program", "Priced Out of Kauaʻi by Lowell"],
          ["/census", "Business Needs Census"],
          ["/resources", "Immediate Resources"],
          ["/transparency", "Transparency & Impact"],
          ["/holiday-fair", "Kamalama Holiday Fair"],
          ["/donate", "Donate"],
          ["/get-involved", "Get Involved"],
        ].map(([to, label]) => (
          <Link
            key={to}
            to={to}
            className="no-underline text-band-foreground/90 transition hover:text-band-foreground"
            data-testid="footer-link"
          >
            {label}
          </Link>
        ))}
      </div>
      <div className="flex flex-col items-start gap-3 text-sm">
        <p className="eyebrow !text-band-foreground/60">Contact</p>
        <a
          href={`mailto:${CONTACT.email}`}
          className="no-underline text-band-foreground/90"
          data-testid="footer-email-link"
        >
          {CONTACT.email}
        </a>
        <a
          href={`tel:+18086318672`}
          className="no-underline text-band-foreground/90"
          data-testid="footer-phone-link"
        >
          {CONTACT.phone}
        </a>
        <span className="text-band-muted">{CONTACT.address}</span>
        <span className="text-band-muted">
          Phone number and mailing address on every page for people who prefer
          not to use forms.
        </span>
      </div>
    </div>
    <div className="border-t border-band-foreground/15">
      <div className="wrap flex flex-wrap items-center justify-between gap-3 py-4 text-xs text-band-muted">
        <span>© {new Date().getFullYear()} Kamalama Foundation · Līhuʻe, Hawaiʻi</span>
        <Link
          to="/admin"
          className="text-band-muted transition hover:text-band-foreground"
          data-testid="footer-admin-link"
        >
          Staff sign-in
        </Link>
      </div>
    </div>
  </footer>
);
